import { render, staticRenderFns } from "./PlaceEdit.vue?vue&type=template&id=530763ca&"
import script from "./PlaceEdit.vue?vue&type=script&lang=js&"
export * from "./PlaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports